import{jsx as o,jsxs as e}from"react/jsx-runtime";import{BackDropLiftContainer as r}from"../BackDropLiftContainer/BackDropLiftContainer.js";import{BottomModalContainer as t}from"../BottomModalContainer/BottomModalContainer.js";import{FullModalContainer as l}from"../FullModalContainer/FullModalContainer.js";import{ModalContainer as i}from"../ModalContainer/ModalContainer.js";import{Portal as n}from"../Portal/Portal.js";import"tailwind-merge";import{Box as a}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";
/**
 * 모달 창을 표시하는 컴포넌트입니다.
 *
 * @component
 * @param {object} props - 모달 컴포넌트 속성
 * @param {boolean} props.isOpen - 모달의 표시 여부를 결정합니다
 * @param {string} [props.rootId] - 모달이 마운트될 DOM 요소의 ID입니다
 * @param {'default' | 'full' | 'bottom'} [props.variant='default'] - 모달의 형태를 지정합니다 (default, full, bottom)
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'} [props.size='md'] - 모달의 크기를 지정합니다 (xs, sm, md, lg, xl, full)
 * @param {'auto' | 'visible' | 'hidden' | 'scroll'} [props.overflow='auto'] - 모달 내용의 오버플로우 처리 방식을 지정합니다 (auto, visible, hidden, scroll)
 * @param {boolean} [props.isBackgroundBlack=true] - 배경색을 검정색으로 할지 여부를 결정합니다
 * @param {boolean} [props.isFixedHeight] - 바텀 시트 모달의 고정 높이 사용 여부를 결정합니다
 * @param {boolean} [props.isPreventScroll=true] - 모달 외부 스크롤 방지 여부를 결정합니다
 * @param {boolean} [props.needCleanup=true] - 모달이 닫힐 때 Portal 정리 여부를 결정합니다
 * @param {() => void} [props.onClose] - 모달이 닫힐 때 실행될 콜백 함수입니다
 * @param {React.ReactNode} props.children - 모달 내부에 표시될 컨텐츠입니다
 *
 * @example
 * // 기본 모달
 * <Modal isOpen={isOpen} onClose={handleClose}>
 *   <div>모달 내용</div>
 * </Modal>
 *
 * // 전체 화면 모달
 * <Modal isOpen={isOpen} variant="full" onClose={handleClose}>
 *   <div>전체 화면 모달 내용</div>
 * </Modal>
 *
 * // 바텀 시트 모달
 * <Modal isOpen={isOpen} variant="bottom" onClose={handleClose}>
 *   <div>바텀 시트 내용</div>
 * </Modal>
 */const s=({isOpen:s,rootId:d,variant:m="default",size:c="md",overflow:p="auto",isBackgroundBlack:u=!0,isFixedHeight:f,isPreventScroll:B=!0,onClose:C,needCleanup:h=!0,children:j})=>{const x="bottom"===m,g="full"===m;/*#__PURE__*/
return o(n,{rootId:d,needCleanup:h&&!d,children:/*#__PURE__*/e(r,{isOpen:s,onClose:C,testId:"design-system--modal",isBackgroundBlack:u,isPreventScroll:B,isBottomSheet:x,children:["default"===m&&/*#__PURE__*/o(a,{className:"full"===c?"px-5":"",children:/*#__PURE__*/o(i,{size:c,overflow:p,children:j})}),g&&/*#__PURE__*/o(l,{children:j}),x&&C&&/*#__PURE__*/o(t,{onClose:C,isFixedHeight:f,children:j})]})})};export{s as Modal};
